import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'sidebar_collapsed';

@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {
  collapsed = signal<boolean>(this.loadFromStorage());

  toggle(): void {
    const next = !this.collapsed();
    this.collapsed.set(next);
    localStorage.setItem(STORAGE_KEY, String(next));
  }

  private loadFromStorage(): boolean {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === 'true';
  }
}
